export const BarHeight = {
    height: '32px',
    minHeight: '32px',
    paddingLeft: '12px'
}

export const BoxEsquerda = {
    height: '100%',
    display: 'flex',
    flexGrow: 1
}

export const BoxDireita = {
    display: 'flex',
    flexGrow: 0
    // gap: 2.5
}

export const BoxName = {
    display: 'flex',
    aligItens: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    // marginLeft: '5px',
    fontSize: '15px',
    textShadow: '1px 1px black',
    paddingLeft: '5px',
    paddingRight: '5px',
    fontWeight: 600
}

export const IconBtn = {
    mr: 1,
    '&:hover': {
        color: '#d1d1d1'
    }
}
